import script from "./Gutter04Extras.vue?vue&type=script&setup=true&lang=js"
export * from "./Gutter04Extras.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__